import { OutboundShipmentTaxId } from "@redotech/redo-fulfillment-customs-common/customs";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useMemo } from "react";
import { FulfillmentCustomsDeclarationsCard } from "../../common/customs-declarations";

export const CustomDeclarationDetailsCard = memo(
  function CustomDeclarationDetailsCard({
    fulfillmentGroup,
    isEditable,
    handleUpdates,
  }: {
    fulfillmentGroup: FulfillmentGroupData;
    handleUpdates: (updates: FulfillmentGroupUpdate[]) => void;
    isEditable: boolean;
  }) {
    const fulfillmentGroups = useMemo(
      () => [fulfillmentGroup],
      [fulfillmentGroup],
    );

    const onUpdateCustomerTaxIds = useMemo(
      () => (taxIds: OutboundShipmentTaxId[]) => {
        handleUpdates([
          { fulfillmentGroupId: fulfillmentGroup._id, customerTaxIds: taxIds },
        ]);
      },
      [fulfillmentGroup._id, handleUpdates],
    );

    return (
      <Flex
        bgColor="primary"
        borderColor="secondary"
        borderStyle="solid"
        borderWidth="1px"
        dir="column"
        flexDirection="column"
        gap="3xl"
        p="3xl"
        radius="md"
        w="full"
      >
        <Text color="secondary" fontSize="sm" fontWeight="medium">
          Customs declarations
        </Text>
        <FulfillmentCustomsDeclarationsCard
          customerTaxIds={fulfillmentGroup.customerTaxIds ?? []}
          fulfillmentGroups={fulfillmentGroups}
          isEditable={isEditable}
          onUpdateCustomerTaxIds={onUpdateCustomerTaxIds}
          updateGroups={handleUpdates}
        />
      </Flex>
    );
  },
);
